/* rt-monitor-close:v2 — add-on to rt-booth.js (loaded right after it).
   The YouTube monitor (#rt-monitor) used to float bottom-right, appear as soon
   as a video-sourced record was LOADED on a deck, and had no way to be closed.
   This file:
     1. docks the monitor at the top of the left rail (falls back to the
        floating corner window on pages where the rail is hidden);
     2. shows ONE monitor at a time, and only once that deck has actually
        played video (class .rt-mon-live, see rt-monitor-close.css);
     3. adds a close button - closing STOPS the deck, because YouTube's embed
        terms do not allow audio from a hidden player;
     4. makes Escape close the open monitor.
   It only uses the public window.RTBooth.decks API, so rt-booth.js is untouched. */
(function () {
  'use strict';

  var wired = false;

  function init() {
    if (wired || !window.RTBooth || !window.RTBooth.decks) return;
    var box = document.getElementById('rt-monitor');
    if (!box) return;
    var fr = /^fr/i.test(document.documentElement.lang || '');
    var label = fr ? 'Fermer la vidéo' : 'Close video';
    var state = {};
    var sides = ['a', 'b'];

    // Moving an iframe in the DOM reloads it, so only re-home the monitor
    // while no YouTube player has been built inside it.
    function place() {
      if (box.querySelector('iframe')) return;
      var rail = document.querySelector('.rt-wrap.rt-rail');
      var booth = rail && rail.querySelector('.rt-booth');
      var railVisible = !!(rail && booth && rail.offsetParent !== null);
      if (railVisible) {
        if (box.parentNode !== rail) rail.insertBefore(box, booth);
        box.classList.add('rt-mon-rail');
      } else {
        if (box.parentNode !== document.body) document.body.appendChild(box);
        box.classList.remove('rt-mon-rail');
      }
    }

    function paint() {
      sides.forEach(function (s) {
        if (state[s]) state[s].mon.classList.toggle('rt-mon-live', state[s].live);
      });
    }

    function show(st) {
      var was = st.live;
      sides.forEach(function (s) { if (state[s]) state[s].live = state[s] === st; });
      if (!was) {
        place();
        var rail = box.parentNode;
        if (rail && rail !== document.body) rail.scrollTop = 0;
      }
      paint();
    }

    function close(st) {
      try { if (st.deck.playing) st.deck.stop(); } catch (e) {}
      st.live = false;
      paint();
    }

    sides.forEach(function (side) {
      var deck = window.RTBooth.decks[side];
      if (!deck || !deck.monEl) return;
      var st = (state[side] = { deck: deck, mon: deck.monEl, live: false, rec: deck.rec });

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rt-mon-close';
      btn.setAttribute('aria-label', label + ' (' + side.toUpperCase() + ')');
      btn.title = label;
      btn.innerHTML = '<svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true" focusable="false"><path d="M1 1l10 10M11 1L1 11" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        close(st);
      });
      deck.monEl.appendChild(btn);

      // Reveal the monitor BEFORE the deck builds its player, so the YouTube
      // iframe is never created inside a display:none box.
      var start = deck.start;
      deck.start = function () {
        if (this.mode === 'video') show(st);
        return start.apply(this, arguments);
      };
    });

    place();
    document.addEventListener('rt:page-swapped', place);

    // The deck exposes no events, so reconcile on a light timer: a newly
    // loaded record resets the monitor, a non-video record hides it, and a
    // video that starts by any path (cue, autoplay, YouTube's own state) shows it.
    setInterval(function () {
      sides.forEach(function (side) {
        var st = state[side];
        if (!st) return;
        var d = st.deck;
        if (d.rec !== st.rec) { st.rec = d.rec; st.live = false; }
        if (d.mode !== 'video') st.live = false;
        else if (d.playing && !st.live) show(st);
      });
      paint();
    }, 300);

    // Capture phase: runs before rt-booth.js's own Escape handler, so one
    // Escape closes the video without also collapsing the booth.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (/^(INPUT|TEXTAREA|SELECT)$/.test((e.target && e.target.tagName) || '')) return;
      var closed = false;
      sides.forEach(function (side) {
        if (state[side] && state[side].live) { close(state[side]); closed = true; }
      });
      if (closed) e.stopImmediatePropagation();
    }, true);

    wired = true;
  }

  init();
  document.addEventListener('rt:booth-ready', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
})();
